import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function UploadIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M4.667 7.333c-.62 0-.93 0-1.185.068a2 2 0 0 0-1.414 1.415C2 9.07 2 9.38 2 10v.8c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 14 4.08 14 5.2 14h5.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C14 12.48 14 11.92 14 10.8V10c0-.62 0-.93-.068-1.184A2 2 0 0 0 12.518 7.4c-.255-.068-.565-.068-1.185-.068m-.666-2.666L8 2m0 0L5.333 4.667M8 2v8" /></svg>
  );
}

export default UploadIcon;
